import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "nav-container"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "nav-ber"
};
const _hoisted_4 = {
  class: "flex m-r-15"
};
const _hoisted_5 = {
  class: "el-dropdown-link flex"
};
const _hoisted_6 = {
  class: "m-r-6 font-weight-600 font-18"
};
const _hoisted_7 = {
  class: "dropdown-menu"
};
const _hoisted_8 = {
  class: "font-22 m-l-10"
};
import { useStore } from "@/store/index";
import { ref, watchEffect, nextTick } from "vue";
import storage from "@/utils/storage";
export default {
  __name: 'Navber',
  setup(__props) {
    const store = useStore();
    const active = ref(false);
    const value = ref(false);
    const theme = ref(storage.get("theme") || "dark");
    const handleTheme = val => {
      theme.value = val ? "light" : "dark";
      storage.set("theme", theme.value);
      store.theme = theme.value;
    };
    watchEffect(() => {
      const subject = theme.value;
      value.value = subject === "light";
      nextTick(() => {
        const html = document.documentElement;
        subject === "dark" ? html.classList.add("dark") : html.classList.remove("dark");
      });
    });
    const handleChange = isShow => {
      if (!isShow) {
        active.value = isShow;
      }
    };
    return (_ctx, _cache) => {
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_lang_select = _resolveComponent("lang-select");
      const _component_el_avatar = _resolveComponent("el-avatar");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(`route.${_ctx.$route.meta.title}`)), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_switch, {
        modelValue: value.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => value.value = $event),
        "active-text": _ctx.$t('common.light'),
        "inactive-text": _ctx.$t('common.dark'),
        onChange: handleTheme
      }, null, 8, ["modelValue", "active-text", "inactive-text"])]), _createVNode(_component_lang_select, {
        class: "right-menu-item hover-effect"
      }), _createVNode(_component_el_dropdown, {
        teleported: false,
        onVisibleChange: handleChange
      }, {
        dropdown: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
          class: "avatar flex",
          onMouseenter: _cache[1] || (_cache[1] = $event => active.value = false)
        }, [_createElementVNode("div", null, [_createVNode(_component_el_avatar, {
          src: _unref(store).info.avatar
        }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(store).info.name), 1)], 32), _createElementVNode("div", {
          class: "dropdown-item",
          onClick: _cache[2] || (_cache[2] = $event => _ctx.$router.push('/personal/personalCenter')),
          onMouseenter: _cache[3] || (_cache[3] = $event => active.value = false)
        }, [_cache[6] || (_cache[6] = _createElementVNode("i", {
          class: "iconfont icon-a-Vector1"
        }, null, -1)), _createElementVNode("span", null, _toDisplayString(_ctx.$t("route.PersonalCenter")), 1)], 32), _createElementVNode("div", {
          class: "dropdown-item",
          onClick: _cache[4] || (_cache[4] = (...args) => _unref(store).getOut && _unref(store).getOut(...args)),
          onMouseenter: _cache[5] || (_cache[5] = $event => active.value = false)
        }, [_cache[7] || (_cache[7] = _createElementVNode("i", {
          class: "iconfont icon-a-guanbi4"
        }, null, -1)), _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.logout")), 1)], 32)])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(_unref(store).info.name), 1), _createVNode(_component_el_avatar, {
          src: _unref(store).info.avatar
        }, null, 8, ["src"])])]),
        _: 1
      })])]);
    };
  }
};